import logger from 'lib/logger'

export const headerContactButtonEvent = () =>
  logger.action('header-contact-button', {
    url: 'https://api.whatsapp.com/send?phone=551131976638&text=Quero%20falar%20com%20a%20EmCasa%20para%20tirar%20d%C3%BAvidas',
    label: 'Fale conosco',
  })

export const breadcrumbEvent = (label: string, url: string) =>
  logger.action('covarage-area-breadcrumb', {
    label,
    url,
  })

export const openRegionsServedPageEvent = () =>
  logger.action('coverage-area-open')

export const cityCardClickEvent = ({
  url,
  label,
  city,
  state,
}: {
  url: string
  label: string
  city: string
  state: string
}) => logger.action('covarage-card-click', { url, label, city, state })
